module.exports = __webpack_public_path__ + "node_modules/icheck/skins/minimal/aero@2x.png?b0242585";